import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ButtonComponent } from "../elements";
import { SidebarContext } from "../../context/Sidebar";

export default function FollowupTableComponent({ thead, tbody }) {
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(20); // Change as needed
    const [userIdToDelete, setUserIdToDelete] = useState(null);
    const [editModal, setEditModal] = useState(false);
    const [blockModal, setBlockModal] = useState(false);
    const { hasPermission } = useContext(SidebarContext);
    useEffect(() => {
        setData(tbody);
    }, [tbody]);

    useEffect(() => {
        const filtered = data.filter(item =>
            item.beneficiary_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.beneficiary_cnic.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.fsf_id.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredData(filtered);
        setCurrentPage(1); // Reset to first page on search
    }, [searchTerm, data]);


   

    // Pagination
    const indexOfLast = currentPage * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;
    const currentRows = filteredData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="mc-table-responsive">
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder={t("search_here")}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead.map((item, index) => (
                            <th key={index}>{item}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {currentRows.map((item, index) => (
                        <tr key={index}>
                            <td title={item?.fsf_id}>{item?.fsf_id}</td>
                            <td title={item?.beneficiary_cnic}>{item?.beneficiary_cnic}</td>
                            <td title={item?.beneficiary_name}>{item?.beneficiary_name}</td>
                            <td title={item?.followup}>{item?.followup}</td>
                            <td title={item?.date_of_visit}>{item?.date_of_visit}</td>
                            <td>
                                <div className="mc-table-action">
                                     {hasPermission("CanEditFollowup") && (
                                    <ButtonComponent
                                        title="Edit"
                                        className="material-icons edit"
                                        onClick={() =>
                                            navigate(`/edit-follow-up/${item.id}`)
                                        }
                                    >
                                        {item?.action?.edit}
                                    </ButtonComponent>
                                     )}
                                    <ButtonComponent
                                        title="View"
                                        className="material-icons view"
                                        onClick={() =>
                                            navigate(`/view-follow-up/${item.id}`)
                                        }
                                    >
                                        {item?.action?.view}
                                    </ButtonComponent>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Pagination Controls */}
            <div className="d-flex justify-content-center mt-3">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(num => (
                    <button
                        key={num}
                        className={`btn btn-sm mx-1 ${currentPage === num ? "btn-primary" : "btn-light text-dark"}`}
                        onClick={() => paginate(num)}
                    >
                        {num}
                    </button>
                ))}
            </div>

           
        </div>
    );
}
